export const ENDPOINTS = {
  auth: {
    login: "/api/login_check",
    password: {
      request_reset: "/api/request-password",
      change: "/api/change-password",
    },
  },
  users: {
    me: "/api/users/me",
    class_types: "/api/user-class-types",
    events: "/api/user-events",
    waiting_events: "/api/user-waiting-events/:id",
    my_notifications: "/api/users/me/notifications",
    vouchers: "/api/users/me/vouchers",
    trainings: "/api/users/me/sessions",
    training_detail: "/api/users/me/sessions/:trainingId",
    finish_training: "/api/users/me/sessions/:trainingId/finish",
  },
  vouchers: "/api/vouchers",
  stripe: {
    checkout: "/api/stripe/checkout",
  },
};



// WEBPACK FOOTER //
// ./src/environments/endpoints/endpoints.api.ts